import React, {useState} from "react"
import PropTypes from "prop-types"
import FilterContext from "../context/FilterContext"
import useMountedRef from "../utility/UseMounted"

type Props = {
    children: React.ReactNode,
	customUrlBase?: string | null,
	isCategoryPage?: boolean | null,
	isBrandPage?: boolean | null,
	categoryOrBrandName?: string | null
}

const FilterContextProvider: React.FC<Props> = ({children, customUrlBase, isCategoryPage, isBrandPage, categoryOrBrandName}) => {
	const [filtersLoading, setFiltersLoading] = useState<boolean>()
	const [customProductsList, setCustomProductsList] = useState<any[]|null>(null)

	const useMounted = useMountedRef()

	const _setFiltersLoading = (onOff: boolean) => {
		if (useMounted.current) {
			setFiltersLoading(onOff)
		}
	}

	return (
		<FilterContext.Provider value={{filtersLoading, setFiltersLoading: _setFiltersLoading, customUrlBase, isCategoryPage, isBrandPage, categoryOrBrandName, customProductsList, setCustomProductsList}}>
			{children}
		</FilterContext.Provider>
	)
}

FilterContextProvider.propTypes = {
	children: PropTypes.node,
	customUrlBase: PropTypes.any,
	isCategoryPage: PropTypes.bool,
	isBrandPage: PropTypes.bool,
	categoryOrBrandName: PropTypes.string
}

export default FilterContextProvider
